<div class="header">
  <ion-button
    fill="clear"
    class="close ion-no-padding"
    (click)="onDismiss()"
    color="white"
  >
    <ion-icon slot="icon-only" name="close" color="white"></ion-icon>
  </ion-button>
</div>

<swiper-container
  #swiperZoom
  class="slides-zoom"
  (swiperafterinit)="ionSlidesDidLoad()"
>
  <swiper-slide>
    <div class="swiper-zoom-container">
      <img [src]="Imagen" alt="" style="border-radius: 4px" />
    </div>

    <ion-spinner
      name="crescent"
      color="white"
      class="spinner"
      *ngIf="spinner"
    ></ion-spinner>
  </swiper-slide>
</swiper-container>
